import { Box, Collapse, Typography, IconButton, TablePagination } from '@mui/material';
import { tableRoleTitle } from '../../data/role.table.title';
import { RoleControllerAction, RoleControllerState } from '../../controller/role.controller';
import lineLoader from '../../../../components/lineLoader/lineLoader';
import { RoleInfoModel } from '../../model/role.model';
const defaultStyle = { border: '1px solid #1A1A1A20', padding: 5, backgroundColor: '#EEEFF3' };
import DeleteIcon from '@mui/icons-material/Delete';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import SecurityIcon from '@mui/icons-material/Security';
import {
  CustomAlertAction,
  CustomAlertState,
} from '../../../../alert/controller/custom.alert.controller';
import { CustomAlertType } from '../../../../alert/data/custom.alert.type';
import { CustomAlertIcons } from '../../../../alert/data/custom.alert.icon';
import { RoleModalChildrenData } from '../../data/role.modal.child';
import { RoleModalNames } from '../../data/role.modal.name';
import checkAuthController from '../../../../layouts/dashboard/controllers/check-auth.controller';
import { useEffect } from 'react';
import { UserInfoModel } from '../../../user/models/user.model';
import { RoleChecker } from '../../../../utils/role-check-utils';
const CustomRoleTable = ({
  role,
  alert,
}: {
  role: RoleControllerState & RoleControllerAction;
  alert: CustomAlertState & CustomAlertAction;
}) => {
  const checkUser = checkAuthController();
  useEffect(() => {
    checkUser.getLoginUser();
  }, []);

  const user: UserInfoModel | null = checkUser.loginUser;
  return (
    <Box
      sx={{
        overflowX: 'auto',
      }}
    >
      <Collapse
        unmountOnExit={true}
        orientation={'vertical'}
        in={role.loading && role?.listCount > 0 ? true : false}
      >
        {lineLoader()}
      </Collapse>
      <Collapse
        unmountOnExit={true}
        orientation={'vertical'}
        in={role.loading == false || role?.listCount > 0 ? true : false}
      >
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr>
              {tableRoleTitle?.map((label, index) => (
                <th key={index} style={{ ...defaultStyle, backgroundColor: '#E4E8F3' }}>
                  <Typography>{label.label}</Typography>
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {role?.listRole?.map((item: RoleInfoModel, index: number) => (
              <tr key={index}>
                <td style={{ ...defaultStyle, textAlign: 'center' }}>
                  <Typography>{index + 1}</Typography>
                </td>

                <td style={{ ...defaultStyle, textAlign: 'center' }}>
                  <Typography>{item?.role_name ?? '*'}</Typography>
                </td>

                <td style={{ ...defaultStyle, textAlign: 'center', textWrap: 'wrap' }}>
                  <Typography>{item?.level}</Typography>
                </td>
                <td style={{ ...defaultStyle, textAlign: 'center' }}>
                  <Typography>{item?.description ?? '*'}</Typography>
                </td>

                <td style={{ ...defaultStyle, textAlign: 'center' }}>
                  <IconButton
                    title="ຈັດການສິດທິ"
                    onClick={() => {
                      role.openPermissionsModal(item);
                      role.onHandleModal(RoleModalChildrenData.find((e) => e.name === RoleModalNames.PERMISSIONS) ?? null);
                    }}
                  >
                    <SecurityIcon />
                  </IconButton>
                  <IconButton
                    onClick={() => {
                      role.onUpdateFormUpdate({
                        id: item?.id,
                        role_name: item.role_name,
                        description: item?.description,
                        level: item?.level,
                      });
                      role.onHandleModal(RoleModalChildrenData[1]);
                    }}
                  >
                    <BorderColorIcon />
                  </IconButton>
                  <IconButton
                    disabled={RoleChecker(user) > 1}
                    onClick={() =>
                      alert.handleCustomAlert({
                        title: 'ລົບຂໍ້ມູນ',
                        message: 'ທ່ານຕ້ອງການລົບຂໍ້ມູນແທ້ບໍ ?',
                        type: CustomAlertType.WARNING,
                        icon: CustomAlertIcons.deleteConfirm,
                        negText: 'ກັບຄືນ',
                        posText: 'ຢືນຢັນ',
                        onPositive: () => {
                          role.onDelete(item.id ?? 0);
                          alert.handleCustomAlert(null);
                        },
                      })
                    }
                  >
                    <DeleteIcon />
                  </IconButton>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </Collapse>
      <Box
        sx={{ display: 'flex', flexDirection: 'row', paddingRight: '20px', alignItems: 'center' }}
      >
        <Typography paddingLeft={'20px'}>ທັງໝົດ {role?.listCount} ລາຍການ</Typography>
        <Box sx={{ flex: 1 }} />
        <TablePagination
          component="div"
          colSpan={3}
          rowsPerPageOptions={[9, 10, 25, 50, 100]}
          count={role?.listCount}
          page={role?.page}
          onPageChange={(_, newPage) => {
            role?.onPageChange(newPage, role?.pageRowAmount);
            role?.onFilterChange({
              ...role?.filter,
              skip: role?.pageRowAmount * newPage,
              take: role?.pageRowAmount,
            });
          }}
          rowsPerPage={role?.pageRowAmount ?? 9}
          onRowsPerPageChange={(e) => {
            const rows = Number.parseInt(e.target.value);
            role?.onPageChange(0, rows);
            role?.onFilterChange({ ...role?.filter, skip: 0, take: rows });
          }}
        />
      </Box>
    </Box>
  );
};

export default CustomRoleTable;
